<template>
    <div class="upload-box">
        <div class="left"><IdeaBox :currentKey="currentKey" :config="config"/></div>
        <div class="right" >
            <ResultBox
                :key="tabelKey"
                :config="tableConfig"
                :list="resultList"
                @remove="handleRemove"
                @copy="addResultData"
                :loading="genLoading"
                @auto-generate="handleAutoGenerate"
                @del-all="handleDelAll"
            />
        </div>
    </div>
</template>

<script>
import IdeaBox from './ideaBox/'
import ResultBox from './resultBox'
import util from '@/libs/utils'
import API from '@/api/marketManage/vivoBatch';
import {  cloneDeep } from 'lodash'
export default {
    name: 'UploadBox',
    props: [ 'config', 'currentKey', 'selectData', 'tableColumn' ],
    provide() {
        return {
            addItem: (...args)=>this.addResultData(...args),
            getKey: ()=> this.currentKey || '',
        }
    },
    inject: {
        hasAll: {
            default: false
        }
    },
    components: {
        ResultBox, IdeaBox
    },
    data() {
        return {
            resultList: [],
            genLoading: false,
            tabelKey: 1
        }
    },
    computed: {
        tableConfig() {
            return this.tableColumn || this.config
        }
    },
    methods: {
        // 清空当前所有选中
        handleDelAll() {
            if (!this.resultList.length) {
                this.$message.error('当前没有选中的素材，请添加')
                return;
            }
            this.editResultData([], this.currentKey)
        },
        handleRemove(prop, id, props) {
            const list = [...this.resultList].map(v=> {
                if (v.id === id) {
                    v[prop] = null
                };
                const hasData = props.some(key=> !!v[key]);
                if (hasData) {
                    return v;
                }else {
                    return null;
                }
            });
            this.editResultData(list.filter(v=> !!v))
        },
        addResultData(data, type, info) {
            let list = [];
            const isAll = this.currentKey ==='key';
            if (data.key && this.currentKey !== data.key && !isAll) {
                list = [ ...(this.selectData[data.key] || []) ]
            }else {
                list = [...this.resultList]
            };
            let prop = info.explicit_name, fileInfo = {};
            switch (type) {
                case 'upload':
                    fileInfo = {
                        ...info,
                        ...data,
                        name: data.name,
                        url: data.fullFilePath
                    };
                    break;
                case 'select':
                    // 兼容复制
                    fileInfo = {
                        ...info,
                        ...data,
                        name: data.material_name || data.name,
                        url: data.full_material_url || data.url,
                    }
                    break;
                default:
                    console.log('未知的操作仅支持【upload、select】');
                   return;
            };
            if (!prop) {
                if (this.hasAll&&data.material_type) {
                    prop = data.material_type === 3 ?'视频':'图片'
                }else {
                     console.log('未知的类型，请检查');
                    return;
                }
            };
            fileInfo.type=type;
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (!item[prop]) {
                    item[prop] = fileInfo;
                    this.editResultData(list, isAll? 'key' : data.key)
                    return
                }
            };
            list.push({
                [prop]: fileInfo,
                id: util.randomString(20)
            });
            this.editResultData(list, isAll? 'key' : data.key)
        },
        editResultData(list,key) {
            if (!key || this.currentKey === key) {
                this.updateResultList(list);
                this.$emit('update', list)
            }else {
                this.$emit('update', list, key)
            }
        },
        updateResultList(list) {
            this.resultList = list
        },
        handleAutoGenerate(col) {
            if (this.genLoading) {
                this.$message.error('正在生成请勿重复点击')
                return
            }
            //
            //  material_name: material_name || name,
            //                     material_url : material_url || filePath;
            const list = [];
            const orgData = col.find(v=> {
                return v.material_type === '3'
            });
            const resolution = orgData.conf_resolution;
            const generateData = col.find(v=> {
                return v.material_type === '1' && v.conf_resolution === resolution;
            });
            if (!(generateData&&orgData)) {
                this.$message.error('图片尺寸与视频不同，暂时无法自动生成')
                return
            }
             const orgProp= orgData.prop;
             const generateProp= generateData.prop;
            let showTip = false;
            const mapList = [ ...this.resultList ];
            mapList.map((v, index)=> {
                if (!v[orgProp]) {
                    return;
                }
                if (!v[generateProp]) {
                    const { img_material_url, img_full_material_url } = v[orgProp]
                    if (img_material_url) {
                        showTip = true;
                        this.$set(v, generateProp, );
                        this.resultList.splice(index, 1, {
                            ...v,
                            [generateProp]: {
                                name: img_material_url.split('/').pop(),
                                url: img_full_material_url,
                                img_full_material_url,
                                filePath: img_material_url,
                                type: 'upload',
                                ...generateData,
                            }
                        });
                        this.$emit('update', this.resultList, this.currentKey)
                    }else {
                       list.push(v)
                    }
                }
            });
            if (showTip&&list.length == 0) {
                return
            }
            this.autoGenerate(list, orgData, generateData)
        },
         autoGenerate(list , orgData, generateData ) {
             const orgProp= orgData.prop;
             const generateProp= generateData.prop;
            if(!list.length) {
                this.$message.error('没有需要生成的素材')
                return;
            };
            this.genLoading = true
            const asyncData = [];

            const currentKey = this.currentKey
            list.forEach(v=> {
                // const name = v.material_name || v.name;
                console.log(v, '1111');
                const video_url =  v[orgProp].material_url || v[orgProp].filePath;
                const params = {
                    video_url,
                    plat_id: '3',//固定传
                };
                asyncData.push(API.genVideoCoverImg(params).then((res)=> {
                    return Object.assign(res, {
                        id: v.id
                    })
                }).catch(error=> {
                    console.log(error);
                    this.$message.error(error.info)
                    return null
                }))
            });
            Promise.all(asyncData).then(list=> {
                list.forEach(res=> {
                    if (res) {
                        const id = res.id;
                        const data = res.data;
                        const selectList = this.selectData[currentKey];
                        const genData = selectList.find(v=>v.id === id);
                        if (genData[generateProp]) {
                            return;
                        }
                        const gen = {
                            ...data,
                            name: data.basename,
                            url: data.fullFilePath,
                            img_full_material_url: data.fullFilePath,
                            type: 'upload',
                            ...generateData,
                        }
                        if (currentKey === this.currentKey) {
                            const index = this.resultList.findIndex(v=>v.id === id);
                            const resultData = this.resultList[index];
                            const orgProp= orgData.prop;
                            const generateProp= generateData.prop;
                            const list = [ ...this.resultList ]
                            list.splice(index, 1, {
                                ...resultData,
                                [orgProp]: resultData[orgProp],
                                [generateProp]: gen,
                            });
                            this.resultList = list;
                        };
                        // 直接复制  待优化
                        genData[generateProp] = gen;
                        this.$emit('update', selectList, currentKey)
                    }
                })
                this.genLoading = false;
                ++this.tabelKey
            })

        }
    }
}
</script>

<style lang="scss" scoped>
.upload-box {
    border: 1px solid #DCDFE6;
    height: 100%;
    margin-right: 50px;
    display: flex;
    position: relative;
    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 38px;
        border: 2px solid #E4E7ED;
    }
    .left {
       border-right: 1px solid #DCDFE6;
       flex: 1;
       width: 0;
    }
    .right {
        width: 420px;
    }
}
</style>
